(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* ============================================================================
     TPS Header: TWO-STATE CONDENSE WITH HYSTERESIS (Hephaestus R8, 2026-10-05, Argus R7-01)
     ----------------------------------------------------------------------------
     Root cause of R7-01: the 2026-06-25 model wrote p = scrollTop / 120 straight into --hp, so EVERY scroll
     position from 1 to 119 px was a resting half state. The nav row's height shrank as calc(48px * (1 - p)) with
     overflow:visible, so its labels hung below the shrinking header (the wrapper's bottom edge and shadow drew a
     line through the descenders at 44 px), and its opacity sat at 1 - p (0.11 at 107 px). A page that can only
     scroll ~107 px (/search with no results) could never leave that state: ghost labels over the breadcrumb.

     The fix keeps the founder-approved full and condensed looks and every --hp calc() in base.css and
     tpw-header-polish.css, but --hp is now only ever 0 or 1:
       full -> condensed when scrollTop >= ENTER (64)   ·   condensed -> full when scrollTop <= LEAVE (16)
     The 48 px dead band is the hysteresis: no scroll position between them flips the state, so a page that
     settles anywhere rests in a whole state. The fixed shell + constant spacer (base.css) mean the flip never
     moves scrollY, so it cannot feed back into itself.
     The move between the two states is a 320 ms exponential ease-out on the registered --hp (@property in
     tpw-header-polish.css ㉕); the nav row is clipped while it moves, so a label is never cut by an edge, only
     faded and tucked. prefers-reduced-motion: no transition, the state snaps.
     Pages that put the header back in flow (the board: --hp:0!important, wrapper position:relative) never
     condense, so the nav there is never made inert while it is still on screen.
     ============================================================================ */
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header'); // fixed shell
      this.headerEl = this.header ? this.header.querySelector('.header') : null; // state target (--hp + classes)
      this.navRow = this.header ? this.header.querySelector('.header-row--medium-nav') : null;
      // sister cross-link and the medium-row account icon fade out in the condensed state; like the nav row they
      // must also leave the tab order + click map once gone.
      this.sisterEl = this.header ? this.header.querySelector('.header-sister') : null;
      this.accountEl = this.header ? this.header.querySelector('.header-row--medium-main .header-account') : null;
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';

      this.ENTER = 64;    // px scrolled before the header condenses
      this.LEAVE = 16;    // px from the top before it opens again
      this.MOVE_MS = 360; // >= the CSS --hp transition (320 ms): the clip and the hide outlast the motion

      this.state = null; // null = not painted yet, 0 = full, 1 = condensed
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.ticking = false;
      this.onScrollHandler = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => { this.onScroll(); this.ticking = false; });
      };
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.desktop.addEventListener('change', () => { this.state = null; this.onScroll(); });

      // Paint the correct state at once (reload mid-page), with no animation.
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    getScrollTop() {
      return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }

    canCondense() {
      // Desktop only, and only while the shell is the fixed one: a page that puts the header back in flow
      // (the board) keeps it whole.
      return this.desktop.matches && getComputedStyle(this).position === 'fixed';
    }

    onScroll() {
      if (!this.headerEl) return;
      const y = this.getScrollTop();
      let s = 0;
      if (this.canCondense()) {
        if (this.state === 1) s = y > this.LEAVE ? 1 : 0;
        else s = y >= this.ENTER ? 1 : 0;
      }
      if (s === this.state) return;

      const el = this.headerEl;
      const instant = this.state === null || this.reduce.matches;
      this.state = s;
      const gone = s === 1;
      const parts = [this.navRow, this.sisterEl, this.accountEl].filter(Boolean);

      clearTimeout(this.moveTimer);
      if (instant) el.classList.add('tps-hdr--instant');
      el.classList.toggle('tps-hdr--moving', !instant);
      el.classList.toggle('tps-hdr--condensed', gone);
      el.style.setProperty('--hp', gone ? '1' : '0');

      // a11y end-state: condensing takes the nav row, the sister cell and the account icon out of the tab order
      // and click map at once (inert); visibility:hidden follows when the fade has finished. Opening gives both
      // back at once, before the row grows in.
      if (this.navRow) this.navRow.setAttribute('aria-hidden', gone ? 'true' : 'false');
      parts.forEach((n) => {
        if ('inert' in HTMLElement.prototype) n.inert = gone;
        if (!gone || instant) n.style.visibility = gone ? 'hidden' : '';
      });

      if (instant) {
        requestAnimationFrame(() => requestAnimationFrame(() => el.classList.remove('tps-hdr--instant')));
      } else {
        this.moveTimer = setTimeout(() => {
          el.classList.remove('tps-hdr--moving');
          if (this.state === 1) parts.forEach((n) => { n.style.visibility = 'hidden'; });
        }, this.MOVE_MS);
      }
      // ALWAYS-PINNED (founder 2026-06-26): no hide-on-scroll-down; the condensed bar stays put at every depth.
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
